module.exports = __webpack_public_path__ + "img/pfletter.b7cbeab2.png";